<template>
    <div v-if="Object.keys(error).length">
        <div v-for="err,index in error">
            <div v-if="index == keyword">
                <div v-for="er,index in err" class="error"> 
                    {{er}}
                </div>
            </div>
          </div>
    </div>
    
</template>
<script >
export default{
    name:'ErrorHandler',
    props:{
        error:{
            type:[Array,Object]
        },
        keyword:{
            type:String
        }
    }
}
</script>